<template>
  <ContainerSmall>
    <img src="/images/Cardstock_Logo.png" class="block mx-auto mt-16 w-48 mb-4">
    <div class="border rounded shadow-md bg-white px-4 py-4 mx-4 sm:mx-0">
      <div class="text-black font-normal text-xl text-center mb-4">
        Create a new password
      </div>

      <Mutation
        :mutation="mutation"
        :variables="variables"
        @done="onDone"
        @error="onError"
      >
        <template v-slot="{ mutate, loading }">
          <ValidationObserver
            ref="observer"
            tag="form"
            @submit.prevent="submit(mutate)"
          >
            <div class="sm:flex sm:items-start my-6">
              <div class="sm:mt-0 sm:text-left w-full">
                <TextInput type="password" v-model="proposedPassword" name="password" label="New password" rules="required|min:8"  vid="confirm"/>
              </div>
            </div>
            <div class="sm:flex sm:items-start my-6">
              <div class="sm:mt-0 sm:text-left w-full">
                <TextInput type="password" v-model="proposedPasswordConfirm" name="passwordConfirm" label="Confirm your new password" rules="confirmed:confirm"/>
              </div>
            </div>

            <button
              type="submit"
              class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-indigo-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-indigo-500 focus:outline-none focus:border-indigo-700 focus:ring-indigo transition ease-in-out duration-150 sm:text-sm sm:leading-5"
              :class="[ loading ? 'bg-gray-500' : 'bg-cardstock-green' ]"
              :disabled="loading"
            >
              Change my password
              <font-awesome-icon v-show="loading" class="ml-2" :icon="['far', 'spinner']" spin/>
            </button>
          </ValidationObserver>
        </template>
      </Mutation>
    </div>
  </ContainerSmall>
</template>

<script>
import _get               from 'lodash-es/get'
import ContainerSmall     from '@/components/ContainerSmall.vue'
import Mutation           from '@/components/Mutation.vue'
import PasswordResetClaim from '@/mutations/PasswordResetClaim.gql'
import SocketLink         from '@/socketLink.js'
import TextInput          from '@/components/TextInput.vue'


export default {
  components: {
    ContainerSmall,
    Mutation,
    TextInput
  },

  data() {
    return {
      proposedPassword: '',
      proposedPasswordConfirm: '',
      mutation: PasswordResetClaim,
      passwordChanged: undefined,
      errored: undefined
    }
  },

  computed: {
    tokenIsValid() {
      _get(this, 'passwordReset.tokenFound')
    },

    variables() {
      return {
        token: this.$route.params.passwordResetToken,
        password: this.proposedPassword
      }
    }
  },

  methods: {
    onDone({passwordResetClaim}) {
      let teacherToken = passwordResetClaim.token
      let userId = passwordResetClaim.userId
      localStorage.setItem('cardstock_auth_token', teacherToken)
      SocketLink.reset()
      this.$router.push({name: 'teams'})
    },

    onError(e) {
      Bus.$emit('flash-message', {text: e, type: 'error'})
    },

    async submit(mutate) {
      const isValid = await this.$refs.observer.validate()
      if (isValid) { mutate() }
    }
  }
}
</script>
